

    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from "../lib/Question";

    @Component({})
    export default class SimpleGuaranteeQuestion extends Vue {
        @Prop()
        public question: Question;
        public guarantees = [];
        public selected = [];
        loadGuarantees() {
            const currentBranch = 1; /* this.question.section.step.branch.id;*/
            const guarantees = this.$store.state.guarantees;
            guarantees.forEach((guarantee) => {
                console.log(guarantee);
                if (guarantee.branch.id === currentBranch) {
                    this.guarantees.push({
                        id: guarantee.id,
                        name: guarantee.label,
                        selected: false,
                        capital: 0,
                    });
                }
            });
        }
        select() {
            this.selected = [];
            this.guarantees.forEach((gu)=>{
                if(gu.selected){
                    this.selected.push(gu);
                }
            });

        }

        save() {
            this.select();
            this.question.currentResponse.value = JSON.stringify(this.selected);
            this.question.changedEvent.emit("");
            this.question.validate();
        }

        mounted() {
            this.loadGuarantees();
            if (this.question.currentResponse.value.length) {
                let value = JSON.parse(this.question.currentResponse.value);
                value.forEach((selected: any) => {
                    const guarantee = this.guarantees.find((guarantee) => guarantee.id === selected.id);
                    if (guarantee) {
                        guarantee.selected = selected.selected;
                        guarantee.capital = selected.capital;
                    }
                });
            }

        }
    }

